module.exports = __webpack_public_path__ + "static/media/order_type_telegram.7bb90214.svg";